export default __webpack_public_path__ + "static/media/face_rec.54029a2a.png";